import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import Header from "../PackageInfo/Header";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import v1 from "../../Images/Vasota/v1.jpg";
import v2 from "../../Images/Vasota/v2.JPG";
import v3 from "../../Images/Vasota/v3.jpg";
import v4 from "../../Images/Vasota/v4.JPG";
import v5 from "../../Images/Vasota/v5.jpg";

import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";

const itinerary = [
  {
    day: "Day 1",
    subheading: "Overnight journey to Bamnoli",
    schedule: [
      { time: "10:00 PM", activity: "Pick-up at Hadapsar." },
      { time: "10:30 PM", activity: "Pick-up at Swargate." },
      { time: "10:50 PM", activity: "Pick-up at Vanaz Metro Station." },
      { time: "11:20 PM", activity: "Pick-up at Wakad Bridge." },
      { time: "11:40 PM", activity: "Pick-up at Navale Bridge." },
      {
        time: "12:00 AM",
        activity:
          "Continue the overnight journey toward the Bamnoli base village.",
      },
    ],
    meals: ["No Meals Provided on Day 1"],
    notes: ["Pickup points are fixed and alternative stops are not available."],
  },
  {
    day: "Day 2",
    subheading: "Boat ride, forest trail, and fort exploration",
    schedule: [
      {
        time: "04:30 AM",
        activity: "Reach base village and stay in tents for a short rest.",
      },
      {
        time: "07:00 AM",
        activity: "freshen up and enjoy breakfast.",
      },
      {
        time: "08:15 AM",
        activity:
          "Hear the final trek briefing from the lead and Begin the scenic boat ride across the Koyna backwaters.",
      },
      {
        time: "10:00 AM",
        activity:
          "Start the forest trail toward the historic Vasota Fort after forest check.",
      },
      {
        time: "11:30 AM",
        activity:
          "Reach the fort plateau and begin exploring the ruins and viewpoints.",
      },
      {
        time: "01:30 AM",
        activity:
          "Begin the return descent through the lush green forest trail.",
      },
      {
        time: "3:00 PM",
        activity: "Board the boat back to the base village.",
      },
      {
        time: "04:30 PM",
        activity: "Reach and enjoy delicious local lunch at base village.",
      },

      { time: "05:30 PM", activity: "Start the return journey to Pune." },
      { time: "10:00 PM", activity: "Approximate arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch", "Evening Tea"],
    notes: [
      "Boat ride and schedule are subject to weather, water level, and local conditions.",
      "Carry a small backpack, water bottle, and lightweight snacks for the whole day.",
    ],
  },
];

const trekMeta = {
  inclusions: [
    "🚌 Pune to Pune Travel by Non-AC Bus",
    "⛴️ Boat ride to and from Vasota Fort",
    "🍽️ Breakfast & Morning Tea",
    "🥘 Delicious Veg & Non-Veg Lunch",
    "🩺 Basic First Aid & Hydration Powder",
    "🧭 Experienced Trek Lead & Guide",
    "🌿 Entry fees and forest charges",
  ],
  exclusions: [
    'Any other charges not mentioned in "Inclusions"',
    "Mineral water, cold drinks, personal food, and extra snacks",
    "Personal expenses, insurance, or any additional activity costs",
  ],
  verticalCards: [
    { title: "Vasota Fort", image: v1 },
    { title: "Koyna Backwaters", image: v2 },
    { title: "Forest Trail", image: v3 },
    { title: "Fort View", image: v4 },
    { title: "Scenic Beauty", image: v5 },
  ],
  trekData: [
    {
      name: "Vasota Fort",
      image: v2,
      info: "Vasota Fort, also known as Vyaghragad, is a majestic hill fort hidden in the lush forests of the Koyna Wildlife Sanctuary in Satara, Maharashtra. Surrounded by the vast backwaters of the Koyna Dam, it is accessible only by a scenic boat ride from Bamnoli village. The trek winds through dense forest, misty valley trails, and steep rocky sections before reaching the fort plateau. The fort offers stunning views of the surrounding Sahyadris, the Koyna reservoir, and the dense green wilderness around it. It is a perfect mix of history, adventure, and natural beauty for trekkers looking for a memorable monsoon or weekend escape.",
    },
  ],
  faq: [
    {
      question: "Where is Vasota Fort located?",
      answer:
        "Vasota Fort is located in the Satara district of Maharashtra, inside the Koyna Wildlife Sanctuary near the Koyna Dam backwaters.",
    },
    {
      question: "How do we reach the fort?",
      answer:
        "The fort is reached by a scenic boat ride from Bamnoli village followed by a short trek through the forest trail to the fort.",
    },
    {
      question: "What is the difficulty level of the Vasota Fort trek?",
      answer:
        "The trek is moderate in difficulty and is suitable for beginners with basic fitness. The route includes forest patches, rocky sections, and a few steep ascents.",
    },
    {
      question: "Is this trek suitable for solo travelers?",
      answer:
        "Yes, solo trekkers are welcome. Many people join individually and enjoy the experience with the group.",
    },
    {
      question: "Do you provide guides and trek leads?",
      answer:
        "Yes, an experienced trek lead and local guide accompany the group to ensure safety and share useful information along the trail.",
    },
    {
      question: "Are washrooms and changing rooms available?",
      answer:
        "Washrooms and changing facilities are usually available at the base village. There are no proper facilities once the trek begins.",
    },
    {
      question: "Is medical assistance available?",
      answer:
        "Basic first aid is available during the trek. Participants are advised to carry personal medicines if needed.",
    },
    {
      question: "What about extra baggage?",
      answer:
        "You may keep your extra luggage in the bus during the trek, but it is at your own responsibility. Please avoid carrying unnecessary items.",
    },
    {
      question: "What type of bus is provided?",
      answer:
        "Travel is by a NON-AC Seater Bus and the configuration may vary based on participant count.",
    },
    {
      question: "What are the pickup points for this trek?",
      answer:
        "Pickup points generally include Hadapsar, Swargate, Vanaz Metro Station, and Wakad or Hinjwadi depending on the departure route.",
    },
    {
      question: "Is prior trekking experience required?",
      answer:
        "No prior experience is required, but a reasonable level of fitness and stamina is recommended for the trail and boat transfer.",
    },
    {
      question: "Is there mobile network coverage on the trail?",
      answer:
        "Mobile connectivity may be weak or unavailable in certain forest sections, so it is wise to inform your family or friends before the trek.",
    },
    {
      question: "Are meals included in the trek package?",
      answer:
        "Yes, breakfast and lunch are included, and the meal is usually a simple, fresh vegetarian spread.",
    },
    {
      question: "Is a boat ride included?",
      answer:
        "Yes, the boat ride to and from the fort is included in the package and adds to the scenic experience of the trek.",
    },
    {
      question: "What should I carry for the trek?",
      answer:
        "Carry a backpack, water bottle, light snacks, rain cover, comfortable trekking shoes, a cap, sunscreen, and any personal medicines. A small extra layer is also useful for the windy fort plateau.",
    },
  ],
};

const VasotaFort = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={trekMeta.trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Vasota Fort"
          location="Satara, Maharashtra"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={itinerary} />
      <ImageCardsWithVerticalView verticalCards={trekMeta.verticalCards} />
      <ModalTriggerList
        inclusions={trekMeta.inclusions}
        exclusions={trekMeta.exclusions}
        type="trek"
        faq={trekMeta.faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default VasotaFort;
